import { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './Complete.module.css';
import { useAppDispatch, useAppSelector } from '../../../hooks/useRedux';

import { Link } from 'react-router-dom';
import { clearCredentials, selectUserEmail } from '../../../features/authSlice';

import { StringByKey } from '../../../types/common';
import { IComplete } from '../../../types/login';

import feedback_password from '../../../assets/images/login/feedback_password.svg';
import feedback_quit from '../../../assets/images/login/feedback_quit.svg';
import feedback_qa from '../../../assets/images/login/feedback_qa.svg';

import {
  ACCOUNT_DELETE_COMPLETE,
  ANNUAL,
  CONFIRM,
  FILE_AUTO_DELETION_DESC,
  LOGIN,
  MEMBERSHIP_CANCEL_COMPLETE,
  MEMBERSHIP_CANCEL_COMPLETE_DESC,
  MEMBERSHIP_RESTART,
  MONTHLY,
  MOVE_MAIN,
  PROFILE_CHANGE_COMPLETE,
  RECOVER_ACCOUNT_COMPLETE,
  REPLY_TO_EMAIL,
  SELPUB_URL,
  SUCCESS_CHANGED_PWD,
  SUCCESS_SIGNUP,
} from '../../../constants';
import { deleteAllTokens, removeLocalStorage } from '../../../utils/storage';
import { VITE_BASE_PUBLIC_PATH, maskEmail } from '../../../utils/util';
import { formatDate } from '../../../utils/date';
import { apiSlice } from '../../../services/api';
import { persistor } from '../../../services/store';

export default function Complete({ name, account, res }: IComplete) {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();
  const email = useAppSelector(selectUserEmail) || account;
  const [maskedEmail, setMaskedEmail] = useState('');
  const mainPageUrl = window.location.hostname.includes('selpub.com')
    ? SELPUB_URL
    : '/';
  const hasOneButton = [
    'profile',
    'withdrawal',
    'contact',
    'cancel-membership',
  ].includes(name);

  const imgSrc: StringByKey = {
    withdrawal: feedback_quit,
    'cancel-membership': feedback_quit,
    contact: feedback_qa,
  };

  const messages: StringByKey = {
    resetPassword: SUCCESS_CHANGED_PWD,
    signup: SUCCESS_SIGNUP,
    profile: PROFILE_CHANGE_COMPLETE,
    withdrawal: `“${email}”
     ${ACCOUNT_DELETE_COMPLETE}`,
    recovery: RECOVER_ACCOUNT_COMPLETE,
    contact: REPLY_TO_EMAIL.replace('{maskedEmail}', maskedEmail),
    'cancel-membership': MEMBERSHIP_CANCEL_COMPLETE,
  };

  const buttons: { [key: string]: { names: string[]; links: string[] } } = {
    'cancel-membership': {
      names: [CONFIRM, MEMBERSHIP_RESTART],
      links: ['../membership', '../membership'],
    },
  };

  const links: StringByKey = {
    profile: '..',
    withdrawal: mainPageUrl,
    contact: mainPageUrl,
    'cancel-membership': '../membership',
  };

  const linkHandler = async ({
    currentTarget,
  }: React.MouseEvent<HTMLAnchorElement>) => {
    if (
      (currentTarget as HTMLAnchorElement).pathname === VITE_BASE_PUBLIC_PATH
    ) {
      removeLocalStorage('loggedIn');
      dispatch(clearCredentials());
      if (name === 'withdrawal') {
        dispatch(apiSlice.util.resetApiState());
        deleteAllTokens();
        await persistor.purge();
      }
    }
  };

  const secondOnClickHandler = async () => {
    if (name === 'cancel-membership') {
      try {
      } catch (error) {}
    }
  };

  useEffect(() => {
    email && setMaskedEmail(maskEmail(email));
  }, []);

  return (
    <>
      <div className={cx('input_area')}>
        <div className={cx('feedback_box')}>
          <img src={imgSrc[name] ?? feedback_password} alt={messages[name]} />
          <p>
            <span dangerouslySetInnerHTML={{ __html: messages[name] }}></span>
          </p>
          {name === 'cancel-membership' && (
            <p className={cx('desc')}>
              {MEMBERSHIP_CANCEL_COMPLETE_DESC.replace(
                '{day}',
                formatDate(res.data.membershipInfo.nextPaymentDate)
              )
                .replace('{membership}', res.data.membershipInfo.nm)
                .replace(
                  '{paymentPeriod}',
                  res.data.membershipInfo.paymentPeriod === 'year'
                    ? ANNUAL
                    : MONTHLY
                )}
              <br />
              <span
                dangerouslySetInnerHTML={{ __html: FILE_AUTO_DELETION_DESC }}
              ></span>
            </p>
          )}
        </div>
      </div>
      <div className={cx('btn_wrap', 'bottom', { cell: !hasOneButton }, name)}>
        {!hasOneButton ? (
          <>
            <button type="button" className={cx('btn', 'b_t', 'dull', 's44')}>
              <Link to={buttons[name]?.links[0] ?? mainPageUrl}>
                <span>{buttons[name]?.names[0] ?? MOVE_MAIN}</span>
              </Link>
            </button>
            <button type="button" className={cx('btn', 'b_t', 's44')}>
              <Link
                to={buttons[name]?.links[1] ?? '/login'}
                onClick={secondOnClickHandler}
              >
                <span>{buttons[name]?.names[1] ?? LOGIN}</span>
              </Link>
            </button>
          </>
        ) : (
          <Link
            to={links[name]}
            className={cx('btn', 'b_t', 's48')}
            onClick={linkHandler}
          >
            <span>{name === 'contact' ? MOVE_MAIN : CONFIRM}</span>
          </Link>
        )}
      </div>
    </>
  );
}
